import React from "react";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";

export default function BsbsSideRoom2({ formData, setFormData }) {
  return (
    <>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">Side Room 2 (Before works)</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Room 2 Name"
                  label="Room's Name"
                  // placeholder="Room's Name"
                  value={formData.sideRoom2Name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      sideRoom2Name: e.target.value,
                    })
                  }
                />
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2TypeOf-label">
                    Type of room
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2TypeOf-label"
                    label="Type of room"
                    id="sideRoom2TypeOf"
                    value={formData.sideRoom2TypeOf}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2TypeOf: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="bedroom">bedroom</MenuItem>
                    <MenuItem value="bathroom">bathroom</MenuItem>
                    <MenuItem value="livingroom">livingroom</MenuItem>
                    <MenuItem value="kitchen">kitchen</MenuItem>
                    <MenuItem value="office">office</MenuItem>
                    <MenuItem value="corridor">corridor</MenuItem>
                    <MenuItem value="basement">basement</MenuItem>
                  </Select>
                </FormControl>

                <FormControl sx={{}} variant="outlined">
                  <OutlinedInput
                    id="sideRoom2Volume"
                    value={formData.sideRoom2Volume}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2Volume: e.target.value,
                      })
                    }
                    endAdornment={
                      <InputAdornment position="end">m3</InputAdornment>
                    }
                    aria-describedby="sideRoom2Volume"
                    inputProps={{
                      "aria-label": "Volume",
                    }}
                  />
                </FormControl>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2LateralWall1-label">
                    Lateral wall 1
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2LateralWall1-label"
                    label="Lateral wall 1"
                    id="sideRoom2LateralWall1"
                    value={formData.sideRoom2LateralWall1}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2LateralWall1: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2LateralWall2-label">
                    Lateral wall 2
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2LateralWall2-label"
                    label="Lateral wall 2"
                    id="sideRoom2LateralWall2"
                    value={formData.sideRoom2LateralWall2}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2LateralWall2: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2Ceiling-label">Ceiling</InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2Ceiling-label"
                    label="Ceiling"
                    id="sideRoom2Ceiling"
                    value={formData.sideRoom2Ceiling}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2Ceiling: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="Enduit (plâtre, ciment,...)">
                      Enduit (plâtre, ciment,...)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur ressorts métalliques">
                      Simples plaques, sur ressorts métalliques
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                      Simples plaques, sur structure métallique suspendue (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                      Simples plaques, sur structure métallique suspendue (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                      Simples plaques, sur structure métallique indépendante
                      (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur lattes en bois Multi-plaques, sur ressorts métalliques">
                      Multi-plaques, sur lattes en bois Multi-plaques, sur
                      ressorts métalliques
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                      Multi-plaques, sur structure métallique suspendue (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                      Multi-plaques, sur structure métallique suspendue (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                      Multi-plaques, sur structure métallique indépendante (avec
                      absorbant)
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2CeilingStructure-label">
                    Ceiling Structure
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2CeilingStructure-label"
                    label="Ceiling Structure"
                    id="sideRoom2CeilingStructure"
                    value={formData.sideRoom2CeilingStructure}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2CeilingStructure: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="prédalles + couche de compression">
                      prédalles + couche de compression
                    </MenuItem>
                    <MenuItem value="hourdis béton + couche de compression">
                      hourdis béton + couche de compression
                    </MenuItem>
                    <MenuItem value="poutrains-claveaux + couche de compression">
                      poutrains-claveaux + couche de compression
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                      solives en bois, sans plaques de sol et de plafond (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol et de plafond (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="autre (lourd)">autre (lourd)</MenuItem>
                    <MenuItem value="autre (semi-lourd)">
                      autre (semi-lourd)
                    </MenuItem>
                    <MenuItem value="autre (léger)">autre (léger)</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2FloorCoating-label">
                    Floor Coating
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2FloorCoating-label"
                    label="Floor Coating"
                    id="sideRoom2FloorCoating"
                    value={formData.sideRoom2FloorCoating}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2FloorCoating: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="chape de ciment">chape de ciment</MenuItem>
                    <MenuItem value="chape anhydrite">chape anhydrite</MenuItem>
                    <MenuItem value="simples plaques, sur couche résiliente">
                      simples plaques, sur couche résiliente
                    </MenuItem>
                    <MenuItem value="simples plaques, sur bandes résilientes (sans absorbant)">
                      simples plaques, sur bandes résilientes (sans absorbant)
                    </MenuItem>
                    <MenuItem value="simples plaques, sur bandes résilientes (avec absorbant)">
                      simples plaques, sur bandes résilientes (avec absorbant)
                    </MenuItem>
                    <MenuItem value="simples plaques, sur plots résilients (sans absorbant)">
                      simples plaques, sur plots résilients (sans absorbant)
                    </MenuItem>
                    <MenuItem value="simples plaques, sur plots résilients (avec absorbant)">
                      simples plaques, sur plots résilients (avec absorbant)
                    </MenuItem>
                    <MenuItem value="multi-plaques, sur couche résiliente">
                      multi-plaques, sur couche résiliente
                    </MenuItem>
                    <MenuItem value="multi-plaques, sur bandes résilientes (sans absorbant)">
                      multi-plaques, sur bandes résilientes (sans absorbant)
                    </MenuItem>
                    <MenuItem value="multi-plaques, sur bandes résilientes (avec absorbant)">
                      multi-plaques, sur bandes résilientes (avec absorbant)
                    </MenuItem>
                    <MenuItem value="multi-plaques, sur plots résilients (sans absorbant)">
                      multi-plaques, sur plots résilients (sans absorbant)
                    </MenuItem>
                    <MenuItem value="multi-plaques, sur plots résilients (avec absorbant)">
                      multi-plaques, sur plots résilients (avec absorbant)
                    </MenuItem>
                    <MenuItem value='solution "Lewis" avec micro-béton, posée sur structure'>
                      solution "Lewis" avec micro-béton, posée sur structure
                    </MenuItem>
                    <MenuItem value='solution "Lewis" avec micro-béton, sur couche résiliente'>
                      solution "Lewis" avec micro-béton, sur couche résiliente
                    </MenuItem>
                    <MenuItem value='solution "Lewis" avec micro-béton, sur bandes résilientes'>
                      solution "Lewis" avec micro-béton, sur bandes résilientes
                    </MenuItem>
                    <MenuItem value='solution "Keep Silence"'>
                      solution "Keep Silence"
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="sideRoom2FLoorStructure-label">
                    FLoor Structure
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="sideRoom2FLoorStructure-label"
                    label="FLoor Structure"
                    id="sideRoom2FLoorStructure"
                    value={formData.sideRoom2FLoorStructure}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sideRoom2FLoorStructure: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="prédalles + couche de compression">
                      prédalles + couche de compression
                    </MenuItem>
                    <MenuItem value="hourdis béton + couche de compression">
                      hourdis béton + couche de compression
                    </MenuItem>
                    <MenuItem value="poutrains-claveaux + couche de compression">
                      poutrains-claveaux + couche de compression
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                      solives en bois, sans plaques de sol et de plafond (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol et de plafond (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="autre (lourd)">autre (lourd)</MenuItem>
                    <MenuItem value="autre (semi-lourd)">
                      autre (semi-lourd)
                    </MenuItem>
                    <MenuItem value="autre (léger)">autre (léger)</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  id="sideRoom2Notes"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  value={formData.sideRoom2Notes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      sideRoom2Notes: e.target.value,
                    })
                  }
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
